module.exports = __webpack_public_path__ + "static/media/3a15fd69-2dde-4e04-b3c6-ae6a01d9b15d.67ca359f.JPG";